import { Link } from 'react-router-dom';

export const RegisterForm = ({ 
  inputs, err, isRegistering, handleChange, handleCheckEmail, handleRegister, handleWeb3Register 
}) => {
  return (
    <div className="right">
        <h1>
            Register
        </h1>

        <form onSubmit={handleRegister}>
            <input 
                type='text' 
                placeholder='Username' 
                name="username" 
                value={inputs.username}
                onChange={handleChange}
                autoComplete="username"
                required
            />

            <input 
                type='email' 
                placeholder='Email' 
                name="email" 
                value={inputs.email}
                onChange={handleChange}
                onBlur={handleCheckEmail}
                autoComplete="email"
                required
            />

            <input 
                type='password' 
                placeholder='Password' 
                name="password" 
                value={inputs.password}
                onChange={handleChange}
                autoComplete="new-password"
                required
            />

            <input 
                type='text' 
                placeholder='Name' 
                name="name" 
                value={inputs.name}
                onChange={handleChange}
                autoComplete="name"
                required
            />

            {err && (
                <div className="error-message">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                        <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11 15V17H13V15H11ZM11 7V13H13V7H11Z"></path>
                    </svg>

                    <span>
                        {err}
                    </span>
                </div>
            )}

            <button type="submit" className="btn-register" disabled={isRegistering}>
                {isRegistering ? "Generating security key..." : "Register"}
            </button>

            <div className="web3-divider" style={{textAlign: "center", margin: "15px 0", color: "gray"}}>
                <span>
                    — OR —
                </span>
            </div>

            <button 
                type="button" 
                className="btn-web3"
                onClick={handleWeb3Register} 
                disabled={isRegistering}
            >
                <svg width="24" height="24" viewBox="0 0 111 111" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M101.9 44.4001L64.8 2.70007L53.4 33.7001L42 2.70007L4.90002 44.4001L22.9 83.1001L40.9 66.8001L53.4 78.4001L65.9 66.8001L83.9 83.1001L101.9 44.4001Z" fill="white"/>
                </svg>
                
                {isRegistering ? "Connecting Wallet..." : "Register with Web3"}
            </button>
        </form>

        <div className="mobileLogin">
            <span>
                Do you have an account?
            </span>

            <Link to="/login"> 
                <button type="button">
                    Login
                </button>
            </Link>
        </div>
    </div>
  );
};